export const popup = {
	position: 'fixed',
	left: 0,
	top: 0,
	right: 0,
	bottom: 0
};

export const PRIMARY_COLOR = '#61DAFB';